import React from 'react';
import { MultiValueProps, components } from 'react-select';
import { SelectOption } from '../MultiFilterDropdown';

const MoreSelectedBadge = ({ items }: { items: string[] }) => {
  const style = {
    marginLeft: '10px',
    fontSize: '14px',
    color: '#285FCB',
    fontFamily: 'Roboto',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0.25px',
    width: '120px',
  };

  const title = items.join(', ');
  const length = items.length;
  const label = `+ ${length} more`;

  return (
    <div style={style} title={title}>
      {label}
    </div>
  );
};

function MultiValueComponent<T>(props: MultiValueProps<SelectOption<T>, true>) {
  const maxToShow = 3;
  const overflow = props
    .getValue()
    .slice(maxToShow)
    .map((x) => x.label);

  return props.index < maxToShow ? (
    <components.MultiValue {...props} />
  ) : props.index === maxToShow ? (
    <MoreSelectedBadge items={overflow} />
  ) : null;
}

export default MultiValueComponent;
